import { GlobalFilters } from "../models/Dashboard";
import { useWidgetContext } from "../components/dashboard/widgets/context";

const useGlobalFilters = (): GlobalFilters => {
  const { globalFilters } = useWidgetContext();
  return globalFilters;
};

export default useGlobalFilters;
